import appRoutes from "../../views/appRoutes/index.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "routes";
  const params = [
    "page",
    "limit",
    "active",
    "dispatch",
    "city",
    "sort",
    "corporate",
    "route_type",
    "private_bus_request",
  ];

  $stateProvider.state("routes", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appRoutes,
      },
    },
    data: { title: "Routes" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/routes/routes.urls.js